module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("i0LIA"))).then(() => parcelRequire('d0iPb'));